<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Vínculo
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm" class="pa-4">
        <v-row class="pl-2 rounded-lg">
          <v-col cols="12" md="6" lg="8">
            <ValidationProvider name="Professor" rules="required" v-slot="{ errors }">
              <e-label>Professor</e-label>
              <e-autocomplete
                :items="professoresList"
                :return-object="false"
                :item-value="(value) => value.id"
                :item-text="(val) => `${val.cpf} - ${val.nome} - ${val.user.roles[0].name}`"
                :error-messages="errors"
                :loading="carregandoProfessores"
                v-model="form.instrutor_id"
                label="Selecione uma opção"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
              <e-label>Tipo do Professor</e-label>
              <v-select
                :items="tipos"
                :item-value="(value) => value.id"
                :item-text="(val) => val.descricao"
                label="Selecione uma opção"
                v-model="form.tipo_professor"
                :error-messages="form.errors ? form.errors : errors"
                dense
                solo
              ></v-select>
            </ValidationProvider>
          </v-col>

          <!-- <v-col class="pt-8 pb-0" cols="6"> </v-col> -->
        </v-row>
        <v-row
          class="animate__animated animate__zoomIn mb-6 pa-2 rounded-lg elevation-1"
          style="animation-duration: 0.5s"
          v-for="relacao of relacoes"
          :key="relacoes.indexOf(relacao)"
        >
          <v-col cols="8" md="6" lg="3">
            <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
              <e-label>Turma</e-label>
              <e-autocomplete
                :items="turmasList"
                :return-object="false"
                :item-value="(value) => value.id"
                :item-text="(val) => val.descricao"
                :error-messages="relacao.errors ? relacao.errors : errors"
                :loading="carregandoTurmas"
                v-model="relacao.turma_id"
                :disabled="editing"
                @change="onTurmaChange(relacao), getEtapasDaTurma(relacao.turma_id)"
                label="Selecione uma opção"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="2" md="4" lg="2">
            <v-container class="" fluid>
              <v-switch
                v-if="!isTurmaInfantil(relacao.turma_id)"
                v-model="relacao.is_polivalencia"
                :label="`Polivalência`"
                :disabled="editing"
                @change="calcularCargaHoraria(relacao)"
              ></v-switch>
              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-switch :value="false" :label="`Polivalência`" disabled></v-switch>
                  </div>
                </template>
                <span>Polivalência não disponível para turmas do ensino infantil</span>
              </v-tooltip>
            </v-container>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <ValidationProvider
              name="Componente Curricular"
              rules="required"
              v-slot="{ errors }"
              v-show="!relacao.is_polivalencia"
            >
              <e-label>Componente Curricular</e-label>
              <e-autocomplete
                :items="relacao.disciplinasDisponiveis"
                :return-object="false"
                :item-value="(value) => value.id"
                :item-text="(val) => val.descricao"
                :error-messages="relacao.errors ? relacao.errors : errors"
                :loading="relacao.carregandoDisciplinas"
                @change="calcularCargaHoraria(relacao)"
                v-model="relacao.disciplina_id"
                :disabled="editing"
                label="Selecione uma opção"
                dense
                solo
              />
            </ValidationProvider>
            <ValidationProvider v-show="relacao.is_polivalencia" name="Componente Curricular">
              <e-label>Componente Curricular para Polivalência</e-label>
              <v-autocomplete
                v-model="relacao.disciplinas_polivalencia"
                :item-value="(value) => value.id"
                :item-text="(val) => val.descricao"
                :items="relacao.disciplinasDisponiveis"
                :loading="relacao.carregandoDisciplinas"
                @change="calcularCargaHoraria(relacao)"
                v-show="!editing"
                chips
                label="Selecione os componentes curriculares"
                multiple
                solo
              ></v-autocomplete>

              <div v-show="editing" v-for="(item, index) in relacao.disciplinas" :key="index">
                <v-chip x-small>{{ item.descricao }}</v-chip>
              </div>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <ValidationProvider name="Carga horária (horas)" rules="required" v-slot="{ errors }">
              <e-label>Carga horária <small>(horas)</small></e-label>
              <v-text-field
                type="number"
                v-model="relacao.carga_horaria"
                dense
                solo
                readonly
                :error-messages="errors"
                min="0"
              />
            </ValidationProvider>
          </v-col>

          <v-col v-if="!editing && relacao.is_polivalencia" cols="12" lg="7">
            <v-card>
              <v-card-title>
                <e-label>Relação de Dias, Horários e Disciplinas</e-label>
              </v-card-title>
              <v-card-text>
                <div v-if="relacoesDiasHorarios.length > 0">
                  <v-row>
                    <v-col class="text-left">
                      <span class="text-uppercase">Horário</span>
                    </v-col>
                    <v-col class="text-left">
                      <span class="text-uppercase">Dia</span>
                    </v-col>
                    <v-col class="text-left">
                      <span class="text-uppercase">Componente Curricular</span>
                    </v-col>
                  </v-row>
                  <v-list>
                    <v-list-item v-for="(item, i) in relacao.horarios" :key="i">
                      <v-row>
                        <v-col class="text-left">
                          {{ item.horario.descricao }}
                        </v-col>
                        <v-col class="text-left">
                          {{ item.dia.descricao }}
                        </v-col>
                        <v-col class="text-left">
                          {{ item.disciplina?.descricao }}
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </div>
                <div v-else>
                  <p class="text-center">Não há horários selecionados</p>
                </div>
                <v-btn
                  color="green white--text"
                  class="mt-3"
                  @click="alterRelacaoIdDialogPolivalencia(relacao)"
                  block
                >
                  {{ editing ? "Dias e horários" : "Dias e horários" }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="!editing && !relacao.is_polivalencia" cols="12" lg="5">
            <v-card>
              <v-card-title>
                <e-label>Relação de Dias e Horários</e-label>
              </v-card-title>
              <v-card-text>
                <div v-if="relacoesDiasHorarios.length > 0">
                  <v-row>
                    <v-col cols="7" class="text-left">
                      <span class="text-uppercase">Horário</span>
                    </v-col>
                    <v-col cols="" class="text-left">
                      <span class="text-uppercase">Dia</span>
                    </v-col>
                  </v-row>
                  <v-list>
                    <v-list-item v-for="(item, i) in relacao.horarios" :key="i">
                      <v-row>
                        <v-col cols="7" class="text-left">
                          {{ item.horario.descricao }}
                        </v-col>
                        <v-col cols="5" class="text-left">
                          {{ item.dia.descricao }}
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </div>
                <div v-else>
                  <p class="text-center">Não há horários selecionados</p>
                </div>
                <v-btn
                  color="green white--text"
                  class="mt-3"
                  @click="alterRelacaoIdDialog(relacao)"
                  block
                >
                  {{ editing ? "Dias e horários" : "Dias e horários" }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="editing && !relacao.is_polivalencia" cols="12" lg="5">
            <v-card>
              <v-card-title>
                <e-label>Relação de Dias e Horários</e-label>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="7" class="text-left">
                    <span class="text-uppercase">Horário</span>
                  </v-col>
                  <v-col cols="" class="text-left">
                    <span class="text-uppercase">Dia</span>
                  </v-col>
                </v-row>
                <v-list>
                  <v-list-item v-for="(item, i) in relacoesDiasHorariosEdit" :key="i">
                    <v-row>
                      <v-col cols="7" class="text-left">
                        {{ item.horario.descricao }}
                      </v-col>
                      <v-col cols="5" class="text-left">
                        {{ item.dia.descricao }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                <v-btn
                  color="green white--text"
                  class="mt-3"
                  @click="alterRelacaoIdDialog(relacao)"
                  block
                >
                  {{ editing ? "Dias e horários" : "Dias e horários" }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-if="editing && relacao.is_polivalencia" cols="12" lg="7">
            <v-card>
              <v-card-title>
                <e-label>Relação de Dias, Horários e Disciplinas</e-label>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col class="text-left">
                    <span class="text-uppercase">Horário</span>
                  </v-col>
                  <v-col class="text-left">
                    <span class="text-uppercase">Dia</span>
                  </v-col>
                  <v-col class="text-left">
                    <span class="text-uppercase">Componente Curricular</span>
                  </v-col>
                </v-row>
                <v-alert
                  v-if="relacoesDiasHorariosEdit.some((h) => !h.disciplina)"
                  dense
                  type="warning"
                  class="mb-2"
                >
                  Existem horários sem componente curricular. Selecione um componente curricular
                  para concluir a edição.
                </v-alert>
                <v-list>
                  <v-list-item v-for="(item, i) in relacoesDiasHorariosEdit" :key="i">
                    <v-row>
                      <v-col class="text-left">
                        {{ item.horario.descricao }}
                      </v-col>
                      <v-col class="text-left">
                        {{ item.dia.descricao }}
                      </v-col>
                      <v-col class="text-left" cols="5">
                        <!-- DISCIPLINA JÁ DEFINIDA -->
                        <!-- <span v-if="item.disciplina && item.disciplina.id">
                          {{ item.disciplina.descricao }}
                        </span> -->

                        <!-- DISCIPLINA AUSENTE -->
                        <v-select
                          v-model="item.disciplina"
                          :items="getDisciplinasParaVinculoPolivalencia(relacao)"
                          :return-object="true"
                          :item-value="(d) => d"
                          :item-text="(d) => d.descricao"
                          dense
                          solo
                          hide-details
                          placeholder="Selecionar componente curricular"
                        />
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                <v-btn
                  color="green white--text"
                  class="mt-3"
                  @click="alterRelacaoIdDialogPolivalencia(relacao)"
                  block
                >
                  {{ editing ? "Dias e horários" : "Dias e horários" }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="5">
            <v-card>
              <v-card-title>
                <e-label>Quantidade de Aulas por etapa</e-label>
              </v-card-title>

              <v-card-text v-if="relacao.turma_id && turmaHasCircuito(relacao.turma_id)">
                <v-row>
                  <v-col
                    cols="6"
                    v-for="etapa in etapasBimestraisList"
                    :key="etapa.id"
                    class="pa-4"
                  >
                    <ValidationProvider
                      :name="`Aulas da etapa ${etapa.descricao}`"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        type="number"
                        min="0"
                        :label="`${etapa.descricao}`"
                        v-model="relacao.relacaoAulasEtapas[etapa.id]"
                        dense
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-alert
                dense
                type="warning"
                v-else-if="relacao.turma_id && !turmaHasCircuito(relacao.turma_id)"
                class="pa-4"
              >
                <span>
                  Esta turma não está vinculada a um circuito de nota. Primeiro vincule a turma a um
                  circuito seguindo: Turmas → editar turma → selecionar um circuito de nota.
                </span>
              </v-alert>

              <div v-else class="pa-4">
                <p class="text-center">
                  <v-icon lg class="mr-2" color="primary">mdi mdi-alert</v-icon>
                  <span>Selecione uma turma primeiro!</span>
                </p>
              </div>
            </v-card>
          </v-col>

          <v-col cols="1">
            <v-btn
              v-if="relacoes.length > 1"
              color="error"
              @click="() => trashRelacao(relacoes, relacao)"
              :disabled="submittingForm"
              ><v-icon small>fa-trash</v-icon></v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="d-flex justify-space-between">
            <div class="d-flex">
              <v-btn
                color="primary"
                :disabled="submittingForm || anyTurmaWithoutCircuito"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-btn
                class="ml-3"
                v-if="!editing"
                color="secondary"
                @click="() => handleSubmit(adicionarRelacao)"
                :disabled="submittingForm || anyTurmaWithoutCircuito"
              >
                Adicionar
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-dialog
          transition="dialog-top-transition"
          v-model="dialogVisiblePolivalencia"
          max-width="800"
        >
          <template>
            <v-card>
              <v-toolbar color="primary" dark
                >Vinculo de dias, horarios e disciplinas
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogVisiblePolivalencia = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-row class="mt-4">
                  <v-col class="pt-0 pb-0" cols="4">
                    <e-label>Dias da semana</e-label>
                    <v-select
                      v-model="dia_da_semana"
                      :items="diasDaSemana"
                      :return-object="true"
                      :item-value="(value) => value"
                      :item-text="(value) => value.descricao"
                      dense
                      solo
                      label="selecione"
                    ></v-select>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="4">
                    <e-label>Horarios</e-label>
                    <v-select
                      v-model="horario_selecionado_id"
                      :items="horariosList"
                      :return-object="false"
                      :item-value="(value) => value"
                      :item-text="(value) => value.descricao"
                      dense
                      solo
                      label="selecione"
                    ></v-select>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="4">
                    <e-label>Componentes Curriculares para o vínculo</e-label>
                    <v-select
                      v-model="disciplina_selecionada_polivalencia"
                      :items="disciplinasParaVinculoPolivalencia"
                      :return-object="true"
                      :item-value="(value) => value"
                      :item-text="(value) => value.descricao"
                      dense
                      solo
                      label="selecione"
                    ></v-select>
                  </v-col>

                  <v-col class="pt-7 pb-0" cols="4">
                    <v-btn
                      :disabled="
                        !dia_da_semana ||
                        !horario_selecionado_id ||
                        !disciplina_selecionada_polivalencia ||
                        carregandoHorarios
                      "
                      :loading="carregandoHorarios"
                      color="green"
                      class="white--text"
                      @click="
                        adicionarHorario(relacoes.indexOf(dialogVisibleRelacaoPolivalenciaId))
                      "
                      >+ adicionar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>

              <v-col v-if="!editing">
                <v-timeline
                  v-show="relacoes.indexOf(dialogVisibleRelacaoPolivalenciaId) == item.relacao_id"
                  align-top
                  dense
                  v-for="(item, i) in relacoesDiasHorarios"
                  :key="i"
                >
                  <v-timeline-item
                    ><v-chip class="mt-1" color="green" text-color="white">
                      {{ item.dia?.descricao }} | {{ item.horario?.descricao }} |
                      {{ item.disciplina?.descricao }}
                    </v-chip>
                    <v-btn
                      class="ml-2"
                      @click="
                        deleteRelacaoDiaHorario(
                          i,
                          relacoes.indexOf(dialogVisibleRelacaoPolivalenciaId)
                        )
                      "
                      color="error"
                      fab
                      small
                      dark
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
              <v-col v-if="editing">
                <v-timeline align-top dense v-for="(item, i) in relacoesDiasHorariosEdit" :key="i">
                  <v-timeline-item>
                    <v-chip class="mt-1" color="green" text-color="white">
                      {{ item.horario?.descricao }} | {{ item.dia?.descricao }} |
                      {{ item.disciplina?.descricao }}
                    </v-chip>

                    <v-btn
                      class="ml-2"
                      @click="
                        deleteRelacaoDiaHorario(
                          i,
                          relacoes.indexOf(dialogVisibleRelacaoPolivalenciaId)
                        )
                      "
                      color="error"
                      fab
                      small
                      dark
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
            </v-card>
          </template>
        </v-dialog>

        <v-dialog transition="dialog-top-transition" v-model="dialogVisible" max-width="800">
          <template>
            <v-card>
              <v-toolbar color="primary" dark
                >Vinculo de dias e horários
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogVisible = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-row class="mt-4">
                  <v-col class="pt-0 pb-0" cols="4">
                    <e-label>Dias da semana</e-label>
                    <v-select
                      v-model="dia_da_semana"
                      :items="diasDaSemana"
                      :return-object="true"
                      :item-value="(value) => value"
                      :item-text="(value) => value.descricao"
                      dense
                      solo
                      label="selecione"
                    ></v-select>
                  </v-col>

                  <v-col class="pt-0 pb-0" cols="4">
                    <e-label>Horarios</e-label>
                    <v-select
                      v-model="horario_selecionado_id"
                      :items="horariosList"
                      :return-object="false"
                      :item-value="(value) => value"
                      :item-text="(value) => value.descricao"
                      dense
                      solo
                      label="selecione"
                    ></v-select>
                  </v-col>

                  <v-col class="pt-7 pb-0" cols="4">
                    <v-btn
                      :disabled="!dia_da_semana || !horario_selecionado_id || carregandoHorarios"
                      :loading="carregandoHorarios"
                      color="green"
                      class="white--text"
                      @click="adicionarHorario(relacoes.indexOf(dialogVisibleRelacaoId))"
                      >+ adicionar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>

              <v-col v-if="!editing">
                <v-timeline
                  v-show="relacoes.indexOf(dialogVisibleRelacaoId) == item.relacao_id"
                  align-top
                  dense
                  v-for="(item, i) in relacoesDiasHorarios"
                  :key="i"
                >
                  <v-timeline-item
                    ><v-chip class="mt-1" color="green" text-color="white">
                      {{ item.dia.descricao }}
                      | {{ item.horario.descricao }}
                    </v-chip>
                    <v-btn
                      class="ml-2"
                      @click="deleteRelacaoDiaHorario(i, relacoes.indexOf(dialogVisibleRelacaoId))"
                      color="error"
                      fab
                      small
                      dark
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
              <v-col v-if="editing">
                <v-timeline align-top dense v-for="(item, i) in relacoesDiasHorariosEdit" :key="i">
                  <v-timeline-item>
                    <v-chip class="mt-1" color="green" text-color="white">
                      {{ item.horario.descricao }} | {{ item.dia.descricao }}
                    </v-chip>

                    <v-btn
                      class="ml-2"
                      @click="deleteRelacaoDiaHorario(i, relacoes.indexOf(dialogVisibleRelacaoId))"
                      color="error"
                      fab
                      small
                      dark
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
            </v-card>
          </template>
        </v-dialog>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    anyTurmaWithoutCircuito() {
      try {
        return this.relacoes.some(
          (r) =>
            r.turma_id && !this.isTurmaInfantil(r.turma_id) && !this.turmaHasCircuito(r.turma_id)
        );
      } catch (e) {
        return false;
      }
    },
    disciplinasParaVinculoPolivalencia() {
      if (
        this.dialogVisibleRelacaoPolivalenciaId &&
        this.dialogVisibleRelacaoPolivalenciaId.is_polivalencia
      ) {
        const selectedDisciplineIds =
          this.dialogVisibleRelacaoPolivalenciaId.disciplinas_polivalencia || [];
        const availableDisciplines =
          this.dialogVisibleRelacaoPolivalenciaId.disciplinasDisponiveis || [];
        return availableDisciplines.filter((d) => selectedDisciplineIds.includes(d.id));
      }
      return [];
    },
  },
  watch: {
    is_polivalencia(value) {
      this.selecionarVariasDisciplinas(value);
    },
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      msgDiasEHorariosObrigatorios: false,
      selectMultiplo: false,
      is_polivalencia: false,
      tipos: [],
      horariosList: [],
      submittingForm: false,
      professoresList: [],
      turmasList: [],
      form: {},
      relacoes: [
        {
          instrutor_id: null,
          tipo_professor: null,
          turma_id: null,
          disciplina_id: null,
          relacoesDiasHorarios: [],
          relacaoAulasEtapas: {},
          disciplinas_polivalencia: [],
          disciplinasDisponiveis: [],
        },
      ],
      disciplinasList: [],
      carregandoProfessores: false,
      carregandoTurmas: false,
      carregandoDisciplinas: false,
      camposObrigatoriosNaoPreenchidos: false,
      relacoesDiasHorarios: [],
      relacoesDiasHorariosEdit: [],
      horario_selecionado_id: null,
      dia_da_semana: null,
      dialogVisible: false,
      dialogVisiblePolivalencia: false,
      dialogVisibleRelacaoPolivalenciaId: false,
      dialogVisibleRelacaoId: 0,
      diasDaSemana: [],
      carregandoHorarios: false,
      etapasBimestraisList: [],
      disciplina_selecionada_polivalencia: null,
    };
  },
  methods: {
    getDisciplinasParaVinculoPolivalencia(relacao) {
      if (!relacao || !relacao.is_polivalencia) return [];

      const selectedIds = relacao.disciplinas_polivalencia || [];
      const available = relacao.disciplinasDisponiveis || [];

      return available.filter((d) => selectedIds.includes(d.id));
    },

    horarioSemDisciplina(item) {
      return !item.disciplina || !item.disciplina.id;
    },

    existeConflitoDiaHorario(dia, horario, ignorarIndex = null) {
      const lista = this.editing ? this.relacoesDiasHorariosEdit : this.relacoesDiasHorarios;

      return lista.some((item, index) => {
        if (ignorarIndex !== null && index === ignorarIndex) {
          return false;
        }

        return item.dia?.id === dia?.id && item.horario?.id === horario?.id;
      });
    },
    trashRelacao(relacoes, relacao) {
      this.relacoes.splice(this.relacoes.indexOf(relacao), 1);
      this.$toast.success("Relação deletada com sucesso!");
    },
    alterRelacaoIdDialogPolivalencia(relacao) {
      this.dia_da_semana = null;
      this.horario_selecionado_id = null;
      this.disciplina_selecionada_polivalencia = null; // Resetar
      this.dialogVisiblePolivalencia = !this.dialogVisiblePolivalencia;
      this.dialogVisibleRelacaoPolivalenciaId = relacao;
      this.getHorariosDaTurma(relacao.turma_id);
      // Preencher os dias da semana apenas com os dias cadastrados na turma
      try {
        const turma = this.turmasList.find((t) => t.id === relacao.turma_id);
        if (turma && turma.dias_da_semana && Array.isArray(turma.dias_da_semana)) {
          const diasMap = {
            "segunda-feira": 0,
            "terça-feira": 1,
            "quarta-feira": 2,
            "quinta-feira": 3,
            "sexta-feira": 4,
            sábado: 5,
            domingo: 6,
          };
          this.diasDaSemana = turma.dias_da_semana
            .map((d) => ({
              id: diasMap[d.toLowerCase()] !== undefined ? diasMap[d.toLowerCase()] : d,
              descricao: d,
            }))
            .sort((a, b) => a.id - b.id);
        } else {
          this.diasDaSemana = [];
        }
      } catch (e) {
        this.diasDaSemana = [];
      }
    },
    alterRelacaoIdDialog(relacao) {
      this.dia_da_semana = null;
      this.horario_selecionado_id = null;
      this.dialogVisible = !this.dialogVisible;
      this.dialogVisibleRelacaoId = relacao;
      this.getHorariosDaTurma(relacao.turma_id);
      // Preencher os dias da semana apenas com os dias cadastrados na turma
      try {
        const turma = this.turmasList.find((t) => t.id === relacao.turma_id);
        if (turma && turma.dias_da_semana && Array.isArray(turma.dias_da_semana)) {
          const diasMap = {
            "segunda-feira": 0,
            "terça-feira": 1,
            "quarta-feira": 2,
            "quinta-feira": 3,
            "sexta-feira": 4,
            sábado: 5,
            domingo: 6,
          };
          this.diasDaSemana = turma.dias_da_semana
            .map((d) => ({
              id: diasMap[d.toLowerCase()] !== undefined ? diasMap[d.toLowerCase()] : d,
              descricao: d,
            }))
            .sort((a, b) => a.id - b.id);
        } else {
          this.diasDaSemana = [];
        }
      } catch (e) {
        this.diasDaSemana = [];
      }
    },
    async adicionarRelacao() {
      this.dia_da_semana = null;
      this.horario_selecionado_id = null;
      const novaRelacao = {
        instrutor_id: null,
        tipo_professor: null,
        turma_id: null,
        disciplina_id: null,
        relacoesDiasHorarios: [],
        relacaoAulasEtapas: {},
        disciplinas_polivalencia: [],
        disciplinasDisponiveis: [],
      };
      this.relacoes.push(novaRelacao);
    },
    async adicionarHorario(relacao) {
      if (!this.dia_da_semana || !this.horario_selecionado_id) {
        this.camposObrigatoriosNaoPreenchidos = true;
        return;
      }

      const conflito = this.existeConflitoDiaHorario(
        this.dia_da_semana,
        this.horario_selecionado_id
      );

      if (conflito) {
        this.$toast.danger("Este horário já está sendo utilizado neste dia.");
        return;
      }

      const data = {
        relacao_id: relacao,
        horario: this.horario_selecionado_id,
        dia: this.dia_da_semana,
        disciplina: this.disciplina_selecionada_polivalencia,
      };

      if (this.editing) {
        this.relacoesDiasHorariosEdit.push(data);
      } else {
        this.relacoesDiasHorarios.push(data);

        if (!this.relacoes[relacao].horarios) {
          this.relacoes[relacao].horarios = [data];
        } else {
          this.relacoes[relacao].horarios.push(data);
        }
      }

      this.camposObrigatoriosNaoPreenchidos = false;
    },

    deleteRelacaoDiaHorario(itemIndex) {
      const item = this.relacoesDiasHorarios[itemIndex];
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esse vínculo?",
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: false,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando o vínculo");
              try {
                this.$toast.success("Vínculo deletado com sucesso");

                // Remover o item da lista relacoesDiasHorarios
                this.relacoesDiasHorarios.splice(itemIndex, 1);

                // Remover o item da lista relacoesDiasHorariosEdit se estiver editando
                if (this.editing) {
                  this.relacoesDiasHorariosEdit.splice(itemIndex, 1);
                }

                // Iterar sobre cada relação para remover o item correspondente
                this.relacoes.forEach((relacao) => {
                  if (relacao && relacao.horarios) {
                    const horarioIndex = relacao.horarios.findIndex(
                      (horario) => horario.relacao_id === item.relacao_id
                    );
                    if (horarioIndex !== -1) {
                      relacao.horarios.splice(horarioIndex, 1);
                    }
                  }
                });

                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },

    async submitForm() {
      this.submittingForm = true;

      try {
        // Editando gestão
        if (this.editing) {
          const formVinculo = {
            ...this.relacoes[0],
            instrutor_id: this.form.instrutor_id,
            tipo_professor: this.form.tipo_professor,
            relacoesDiasHorarios: this.relacoesDiasHorariosEdit,
            relacaoAulasEtapas:
              this.relacoes[0].relacaoAulasEtapas &&
              !Array.isArray(this.relacoes[0].relacaoAulasEtapas)
                ? this.relacoes[0].relacaoAulasEtapas
                : {},
          };

          if (formVinculo.relacoesDiasHorarios.length === 0) {
            this.$toast.danger("Preencha os campos obrigatórios: Dias da semana e Horários.");
            this.submittingForm = false;
            return;
          }

          if (formVinculo.is_polivalencia) {
            const possuiHorarioSemDisciplina = formVinculo.relacoesDiasHorarios.some(
              (item) => !item.disciplina || !item.disciplina.id
            );

            if (possuiHorarioSemDisciplina) {
              this.$toast.danger(
                "Para vínculos de polivalência, todos os dias e horários devem possuir um componente curricular."
              );
              this.submittingForm = false;
              return;
            }
          }

          await this.$services.gestoesDeAulasService.atualizar(formVinculo);
          this.$toast.success("Vínculo atualizado com sucesso!");
        }

        // Criando uma nova gestão
        if (!this.editing) {
          const formRelacoes = this.relacoes.map((relacao, index) => ({
            ...relacao,
            instrutor_id: this.form.instrutor_id,
            tipo_professor: this.form.tipo_professor,
            is_polivalencia: relacao.is_polivalencia ? relacao.is_polivalencia : 0,
            relacoesDiasHorarios: this.relacoesDiasHorarios.filter((r) => r.relacao_id === index),
            relacaoAulasEtapas:
              relacao.relacaoAulasEtapas && !Array.isArray(relacao.relacaoAulasEtapas)
                ? relacao.relacaoAulasEtapas
                : {},
          }));

          if (formRelacoes.some((relacao) => relacao.relacoesDiasHorarios.length === 0)) {
            this.$toast.danger("Preencha os campos obrigatórios: Dias da semana e Horários.");
            this.submittingForm = false;
            return;
          }

          const responseData = await this.$services.gestoesDeAulasService.criar(formRelacoes);

          this.relacoes = responseData
            .filter((item) => item.errors)
            .map((item) => ({
              ...item,
              relacaoAulasEtapas:
                item.relacaoAulasEtapas && !Array.isArray(item.relacaoAulasEtapas)
                  ? item.relacaoAulasEtapas
                  : {},
            }));
          this.$toast.success("Vínculo(s) criado(s) com sucesso!");
        }

        if (this.relacoes.length === 0 || this.editing) {
          this.$toast.success("Vínculos criados/atualizados com sucesso");
          this.$router.push({ name: "gestoesDeAulas" });
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },

    async loadData() {
      try {
        this.$loaderService.open("Carregando dados");
        this.professoresList = await this.$services.professoresService.syncAll();
        this.tipos = await this.$services.professoresService.tipos();
        this.turmasList = await this.$services.turmasService.syncAll();
        this.disciplinasList = await this.$services.disciplinasService.syncAll();
        this.horariosList = await this.$services.horariosService.syncAll();

        if (this.editing) {
          const vinculo = await this.$services.gestoesDeAulasService.gestaoGeralId(
            parseInt(this.$route.params.gestaoDeAulasId, 10)
          );

          this.relacoesDiasHorariosEdit = vinculo.relacoesDiasHorarios ?? [];
          this.form.is_polivalencia = vinculo.is_polivalencia;

          if (vinculo.tipo_professor) {
            this.form.tipo_professor = vinculo.tipo_professor;
          }
          if (vinculo) {
            // Unifica o modelo de dados para polivalencia no modo de edição
            if (vinculo.is_polivalencia && vinculo.disciplinas) {
              vinculo.disciplinas_polivalencia = vinculo.disciplinas.map((d) => d.id);
            }

            this.form.instrutor_id = vinculo.instrutor_id;
            vinculo.relacaoAulasEtapas =
              vinculo.relacaoAulasEtapas && !Array.isArray(vinculo.relacaoAulasEtapas)
                ? vinculo.relacaoAulasEtapas
                : {};
            this.relacoes = [vinculo];

            if (this.relacoes[0] && this.relacoes[0].turma_id) {
              await this.getDisciplinasDaTurma(this.relacoes[0]);
              this.calcularCargaHoraria(this.relacoes[0]);
            }
          }
          await this.getEtapasDaTurma(vinculo.turma_id);
          this.getHorariosDaTurma(vinculo.turma_id);
        }
        this.$loaderService.close();
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
    },

    async onTurmaChange(relacao) {
      // Limpa a seleção de disciplina anterior
      relacao.disciplina_id = null;
      relacao.disciplinas_polivalencia = [];
      if (this.isTurmaInfantil(relacao.turma_id)) {
        relacao.is_polivalencia = false;
      }
      // Chama os métodos para buscar horários e disciplinas
      this.getHorariosDaTurma(relacao.turma_id);
      this.getDisciplinasDaTurma(relacao);
    },
    isTurmaInfantil(turma_id) {
      if (!turma_id) return false;
      const turma = this.turmasList.find((t) => t.id === turma_id);
      return turma && turma.isInfantil === true;
    },
    async getDisciplinasDaTurma(relacao) {
      if (!relacao.turma_id) {
        this.$set(relacao, "disciplinasDisponiveis", []);
        return;
      }
      this.$set(relacao, "carregandoDisciplinas", true);
      try {
        // Presume-se que um novo método de serviço exista para buscar as disciplinas da turma
        const disciplinas = await this.$services.turmasService.getDisciplinas(relacao.turma_id);

        this.$set(relacao, "disciplinasDisponiveis", disciplinas);
      } catch (error) {
        this.$toast.danger("Erro ao carregar as disciplinas da turma.");
        this.$set(relacao, "disciplinasDisponiveis", []);
      } finally {
        this.$set(relacao, "carregandoDisciplinas", false);
      }
    },
    calcularCargaHoraria(relacao) {
      let cargaTotal = 0;
      const disciplinasDisponiveis = relacao.disciplinasDisponiveis || [];
      if (relacao.is_polivalencia) {
        // Múltiplas disciplinas
        if (relacao.disciplinas_polivalencia && relacao.disciplinas_polivalencia.length > 0) {
          relacao.disciplinas_polivalencia.forEach((disciplinaId) => {
            const disciplina = disciplinasDisponiveis.find((d) => d.id === disciplinaId);
            if (disciplina && disciplina.pivot && disciplina.pivot.carga_horaria_disciplina) {
              cargaTotal += parseFloat(disciplina.pivot.carga_horaria_disciplina);
            }
          });
        }
      } else if (relacao.disciplina_id) {
        // Disciplina única
        const disciplina = disciplinasDisponiveis.find((d) => d.id === relacao.disciplina_id);
        if (disciplina && disciplina.pivot && disciplina.pivot.carga_horaria_disciplina) {
          cargaTotal = parseFloat(disciplina.pivot.carga_horaria_disciplina);
        }
      }
      this.$set(relacao, "carga_horaria", cargaTotal);
    },
    async getHorariosDaTurma(turmaParam) {
      this.$loaderService.open("Carregando horários");
      this.carregandoHorarios = true;
      try {
        // aceitar tanto objeto { turma_id } quanto id simples
        const turma_id =
          turmaParam && typeof turmaParam === "object" ? turmaParam.turma_id : turmaParam;

        if (turma_id) {
          // preencher diasDaSemana a partir da turma selecionada
          try {
            const turma = this.turmasList.find((t) => t.id === turma_id);
            if (turma && turma.dias_da_semana && Array.isArray(turma.dias_da_semana)) {
              const diasMap = {
                "segunda-feira": 0,
                "terça-feira": 1,
                "quarta-feira": 2,
                "quinta-feira": 3,
                "sexta-feira": 4,
                sábado: 5,
                domingo: 6,
              };
              this.diasDaSemana = turma.dias_da_semana.map((d) => ({
                id: diasMap[d.toLowerCase()] !== undefined ? diasMap[d.toLowerCase()] : d,
                descricao: d,
              }));
            } else {
              this.diasDaSemana = [];
            }
          } catch (e) {
            this.diasDaSemana = [];
          }

          this.horariosList = await this.$services.horariosService.getHorariosDoTurnoDaTurma(
            turma_id
          );
        } else {
          this.horariosList = [];
          this.diasDaSemana = [];
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar horários", error);
      } finally {
        this.$loaderService.close();
        this.carregandoHorarios = false;
      }
    },

    async getEtapasDaTurma(turma_id) {
      this.$loaderService.open("Carregando etapas");
      try {
        // Se a turma não tiver circuito de nota, não chama a API (evita 400)
        if (!this.turmaHasCircuito(turma_id)) {
          this.etapasBimestraisList = [];
          // garantir que relacaoAulasEtapas esteja vazia quando não houver circuito
          if (this.editing && this.relacoes[0]) {
            this.$set(this.relacoes[0], "relacaoAulasEtapas", {});
          }
          return;
        }

        const response = await this.$services.etapasService.getEtapasBimestrais(turma_id);
        this.etapasBimestraisList = response;

        if (this.editing && this.relacoes[0]) {
          if (
            !this.relacoes[0].relacaoAulasEtapas ||
            Array.isArray(this.relacoes[0].relacaoAulasEtapas)
          ) {
            this.$set(this.relacoes[0], "relacaoAulasEtapas", {});
          }

          response.forEach((etapa) => {
            if (
              !Object.prototype.hasOwnProperty.call(this.relacoes[0].relacaoAulasEtapas, etapa.id)
            ) {
              this.$set(this.relacoes[0].relacaoAulasEtapas, etapa.id, "");
            }
          });
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    turmaHasCircuito(turmaParam) {
      try {
        const turma_id =
          turmaParam && typeof turmaParam === "object" ? turmaParam.turma_id : turmaParam;
        const turma = this.turmasList.find((t) => t.id === turma_id);
        return Boolean(turma && turma.circuito_nota_id);
      } catch (e) {
        return false;
      }
    },
  },
};
</script>

<style></style>
